import { ENV_TYPE } from 'lib/constants/login';
import { urlConfig, config } from 'lib/config';
import { AxiosPromise } from 'axios';
import msdkUtil from '../MSDK/index';
import session from '../session';
import HttpRequest from './request';
import sessionRequest from './login';

const PREFIX_URL = {
  [ENV_TYPE.GUEST]: '/v2',
  [ENV_TYPE.MSDK]: '/v1',
  [ENV_TYPE.THIRD_LOGIN]: '/v1',
};

class NetWork {
  private requestInstance: HttpRequest;
  private requestNodeInstance: HttpRequest;
  private requestGatewayInstance: HttpRequest;
  private loginStatus: ENV_TYPE;
  private serviceType: string;
  constructor() {
    this.loginStatus = ENV_TYPE.GUEST;
    this.requestInstance = new HttpRequest({
      baseUrl: urlConfig.baseUrl,
    });
    this.requestNodeInstance = new HttpRequest({
      baseUrl: urlConfig.nodeUrl,
    });
    this.requestGatewayInstance = new HttpRequest({
      baseUrl: urlConfig.gatewayUrl,
    });
  }

  public setServiceType(serviceType) {
    this.serviceType = serviceType;
  }

  public setLoginStatus(loginStatus) {
    this.loginStatus = loginStatus;
  }

  public request(options: any): AxiosPromise<any> | undefined {
    if (!this.serviceType && !options.data?.serviceType) return;
    if (options.isAMS) {
      return this.requestAMS(options);
    }
    const noToken = this.loginStatus === ENV_TYPE.GUEST;
    if (options.needLogin && noToken) return;
    const url = options.WUJI ? options.url : `${PREFIX_URL[this.loginStatus]}${options.url}`;
    if (options.isNodeApi) {
      return this.requestNode(options);
    }
    if (options.isGateway) {
      return this.requestGateway({ ...options, url });
    }
    if (msdkUtil.isMSDK) {
      return this.requestMSDK({ ...options, url });
    }
    return this.requestNoMSDK({ ...options, url });
  }

  public wujiRequest(options) {
    return this.requestNoMSDK({ ...options, url: options.url });
  }

  public requestAMS(options) {
    return sessionRequest.fetchAMSRequest({
      baseURL: options.baseURL,
      url: options.url,
      params: msdkUtil.MSDKParams,
      headers: {
        loginType: this.loginStatus,
        serviceType: this.serviceType,
        msdkVersion: msdkUtil.MSDKVersion || '',
        Authorization: session.getSessionData().token || '',
      },
      data: {
        ...options.data,
      },
    });
  }

  public requestNode(options: any): AxiosPromise<any> | undefined {
    if (!this.serviceType && !options.data?.serviceType) return;
    const noToken = this.loginStatus === ENV_TYPE.GUEST;
    if (options.needLogin && noToken) return;
    if (msdkUtil.isMSDK) {
      return this.requestMSDKCommon({ ...options });
    }
    return this.requestNoMSDKCommon({ ...options });
  }

  public requestGateway(options: any): AxiosPromise<any> | undefined {
    if (msdkUtil.isMSDK) {
      return this.requestMSDKCommon({ ...options });
    }
    return this.requestNoMSDKCommon({ ...options });
  }

  private requestMSDKCommon(options: any) {
    const params = { ...msdkUtil.MSDKParams, ...(config.env === 'gray' ? { canaryclient: config.env } : {}) };
    const requestOption = {
      ...options,
      params,
      data: {
        ...options.data,
        msdkVersion: msdkUtil.MSDKVersion,
      },
    };
    if (options.isGateway) {
      return this.gatewayRequest(requestOption);
    }
    return this.nodeRequest(requestOption);
  }

  private requestNoMSDKCommon(options: any) {
    if (this.loginStatus !== ENV_TYPE.GUEST) {
      options.data = {
        ...options.data,
        Authorization: session.getSessionData().token || '',
      };
    }
    const params = config.env === 'gray' ? { canaryclient: config.env } : {};
    const requestOption = {
      ...options,
      params,
    };
    if (options.isGateway) {
      return this.gatewayRequest(requestOption);
    }
    return this.nodeRequest(requestOption);
  }

  private requestMSDK(options: any) {
    return this.commonRequest({
      ...options,
      params: msdkUtil.MSDKParams,
      data: {
        ...options.data,
        msdkVersion: msdkUtil.MSDKVersion,
      },
    });
  }

  private requestNoMSDK(options: any) {
    if (this.loginStatus !== ENV_TYPE.GUEST) {
      options.data = {
        ...options.data,
        Authorization: session.getSessionData().token || '',
      };
    }
    return this.commonRequest({
      ...options,
    });
  }

  private commonRequest(options: any) {
    return this.requestInstance.request({
      ...options,
      params: options.params,
      data: {
        loginType: this.loginStatus,
        serviceType: this.serviceType,
        ...options.data,
      },
    });
  }

  private nodeRequest(options: any) {
    return this.requestNodeInstance.request({
      ...options,
      params: options.params,
      data: {
        loginType: this.loginStatus,
        serviceType: this.serviceType,
        ...options.data,
      },
    });
  }

  private gatewayRequest(options: any) {
    return this.requestGatewayInstance.request({
      ...options,
      params: options.params,
      data: {
        loginType: this.loginStatus,
        serviceType: this.serviceType,
        ...options.data,
      },
    });
  }
}

const network = new NetWork();

export default network;
